import BackButton from "components/Button/BackButton"
import DeleteButton from "components/Button/DeleteButton"
import SaveButton from "components/Button/SaveButton"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { DropdownGender, DropdownVehicleOptions, EmptyString, FormTypeAdd, FormTypeEdit, FormTypeView, StatusCodeActive, StatusCodeDelete } from "utils/Constant"
import moment from "moment"
import { GetGender, GetVehicle, removeNonNumeric } from "utils/helpers"
import UnDeleteButton from "components/Button/UnDeleteButton"
import DatePicker from "components/Input/DatePicker"
import Dropdown from "components/Input/Dropdown"
import ImageIcon from "assets/icon/ImageIcon"
import { MainBodyCard } from "components/Cards/MainBodyCard"
import { useModal } from "utils/context/ModalContext"
import { TenantService } from "services/TenantService"
import { FormCard } from "components/Cards/FormCard"
import { PagesFormTitle } from "components/Cards/PagesFormTitle"
import imageCompression from 'browser-image-compression';

export default function TenantForm(){
    const navigate = useNavigate()

    const { showLoading, hideLoading, showSuccess, confirm } = useModal()

    const { fetchCreateTenant, fetchUpdateTenant, fetchDeleteTenant, fetchTenantById } = TenantService()

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let tenantId = queryString.get("tenantId")

    const [tenantName, setTenantName] = useState(EmptyString)
    const [idNumber, setIdNumber] = useState(EmptyString)
    const [placeOfBirth, setPlaceOfBirth] = useState(EmptyString)
    const [dateOfBirth, setDateOfBirth] = useState(new Date())
    const [address, setAddress] = useState(EmptyString)
    const [city, setCity] = useState(EmptyString)
    const [province, setProvince] = useState(EmptyString)
    const [country, setCountry] = useState("Indonesia")
    const [phone, setPhone] = useState(EmptyString)
    const [file, setFile] = useState(EmptyString)
    const [fileUrl, setFileUrl] = useState(EmptyString)
    const [gender, setGender] = useState(DropdownGender[0].value)
    const [vehicle, setVehicle] = useState(DropdownVehicleOptions[0].value)
    const [vehicleBrand, setVehicleBrand] = useState(EmptyString)
    const [vehicleModel, setVehicleModel] = useState(EmptyString)
    const [licensePlate, setLicensePlate] = useState(EmptyString)
    const [contactName, setContactName] = useState(EmptyString)
    const [contactPhone, setContactPhone] = useState(EmptyString)
    const [contactRelation, setContactRelation] = useState(EmptyString)
    const [workPlace, setWorkPlace] = useState(EmptyString)

    // HEADER
    const [createDate, setCreateDate] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)
    
    const handleChange = async (e) => {
        const selectedFile = e.target.files[0];
        if (!selectedFile) return;

        // Check if file is an image before attempting compression
        if (selectedFile.type.startsWith('image/')) {
            const options = {
                maxSizeMB: 1,            // Target maximum size in MB
                maxWidthOrHeight: 1920,   // Resize if image resolution is very large
                useWebWorker: true,      // Run in background thread to prevent UI freezing
            };

            try {
                // Compress file if it exceeds 1MB (or auto-optimize)
                const compressedFile = await imageCompression(selectedFile, options);

                setFile(compressedFile);
                setFileUrl(URL.createObjectURL(compressedFile));
            } catch (error) {
                console.error('Error compressing file:', error);
                // Fallback to original file if compression fails
                setFile(selectedFile);
                setFileUrl(URL.createObjectURL(selectedFile));
            }
        } else {
            // Non-image files (e.g. PDF) are passed without compression
            setFile(selectedFile);
            setFileUrl(URL.createObjectURL(selectedFile));
        }
    }

    // const handleChange = (e) => {
    //     setFile((e.target.files[0]));
    //     if (e.target.files[0] != null) {
    //         setFileUrl(URL.createObjectURL(e.target.files[0]));
    //     }
    // }

    const saveBtnClick = async () => {
        if (!validateForm()) return

        const onConfirm = await confirm()
        if (!onConfirm) return

        try {
            showLoading()

            if (formType === FormTypeAdd){
                const res = await fetchCreateTenant(
                    tenantName.trim(),
                    gender,
                    idNumber,
                    placeOfBirth,
                    moment(dateOfBirth).format("yyyy-MM-DD"),
                    address,
                    city,
                    province,
                    country,
                    phone,
                    file,
                    workPlace,
                    vehicle,
                    vehicleBrand,
                    vehicleModel,
                    licensePlate,
                    contactName,
                    contactPhone,
                    contactRelation
                )

                if (!res) return 

                showSuccess({
                    onSuccess: () => {
                        navigate('/tenant')
                    }
                })
            } else {
                const res = await fetchUpdateTenant(
                    tenantId,
                    tenantName.trim(),
                    gender,
                    idNumber,
                    placeOfBirth,
                    moment(dateOfBirth).format("yyyy-MM-DD"),
                    address,
                    city,
                    province,
                    country,
                    phone,
                    file,
                    workPlace,
                    vehicle,
                    vehicleBrand,
                    vehicleModel,
                    licensePlate,
                    contactName,
                    contactPhone,
                    contactRelation
                )

                if (!res) return 

                showSuccess({
                    onSuccess: () => {
                        navigate('/tenant')
                    }
                })
            }
        } finally {
            hideLoading()
        }
    }
    const deleteBtnClick = async () => {
        const onConfirm = await confirm()
        if (!onConfirm) return

        try {
            showLoading()

            const res = await fetchDeleteTenant(tenantId, status)
            if (!res) return

            showSuccess({
                onSuccess: () => {
                    navigate('/tenant')
                }
            })
        } finally {
            hideLoading()
        }
    }
    const backBtnClick = () => {
        navigate(-1)
    }

    function validateForm(){
        let errorCount = 0

        

        

        if (errorCount > 0){
            return false
        }else{
            return true
        }
    }

    const getTenantById = async () => {
        const res = await fetchTenantById(tenantId)
        if (!res) return

        const data = res.data
        
        setTenantName(data.tenantName)
        setGender(data.gender)
        setIdNumber(data.idNumber)
        setPlaceOfBirth(data.placeOfBirth)
        setDateOfBirth(data.dateOfBirth)
        setAddress(data.address)
        setCity(data.city)
        setProvince(data.province)
        setCountry(data.country)
        setPhone(data.phone)
        setStatus(data.status)
        setCreateDate(data.createDate)
        setUpdateDate(data.updateDate)
        setUpdateBy(data.updateBy)
        if (data.photoURL !== null || data.photoURL !== EmptyString){
            setFileUrl(data.photoURL)
        }
        setWorkPlace(data.workPlace)
        setVehicle(data.vehicle === null ? '' : data.vehicle)
        setVehicleBrand(data.vehicleBrand)
        setVehicleModel(data.vehicleModel)
        setLicensePlate(data.licensePlate)
        setContactName(data.contactName)
        setContactPhone(data.contactPhone)
        setContactRelation(data.contactRelation)
    }

    useEffect(() => {
        const onLoad = async () => {
            try {
                showLoading()

                if (formType === FormTypeEdit || formType === FormTypeView){
                    await getTenantById()
                }
            } finally {
                hideLoading()
            }
        }

        onLoad()
    }, [])

    useEffect(() => {
        return () => {
            if (fileUrl) {
                URL.revokeObjectURL(fileUrl)
            }
        };
    }, [fileUrl])

    return (
        <MainBodyCard>
            <PagesFormTitle
                title='Tenant Detail'
                formType={formType}
                status={status}
                createDate={createDate}
                updateBy={updateBy}
                updateDate={updateDate}
            />

            <div className="mt-5 flex flex-col gap-3">
                <FormCard title='Tenant Name'>
                    {formType === FormTypeView ? 
                        <label>{tenantName}</label> :
                        <input className="input" value={tenantName} onChange={(e) => setTenantName(e.target.value.toUpperCase())} />
                    }
                </FormCard>

                <FormCard title='Gender'>
                    {formType === FormTypeView ? 
                        <label>{ GetGender(gender) }</label> :
                        <Dropdown className="" options={DropdownGender} value={gender} onChange={(e) => setGender(e.value)} />
                    }
                </FormCard>

                <FormCard title='ID Number'>
                    {formType === FormTypeView ? 
                        <label>{ idNumber }</label> :
                        <input className="input" value={idNumber} onChange={(e) => setIdNumber(removeNonNumeric(e.target.value))} />
                    }
                </FormCard>

                <FormCard title='Place of Birth'>
                    {formType === FormTypeView ? 
                        <label>{ placeOfBirth }</label> :
                        <input className="input" value={placeOfBirth} onChange={(e) => setPlaceOfBirth(e.target.value.toUpperCase())} />
                    }
                </FormCard>

                <FormCard title='Date of Birth'>
                    {formType === FormTypeView ? 
                        <label>{ moment(dateOfBirth).format('DD MMMM yyyy') }</label> :
                        <DatePicker className="bg-white w-full h-11" value={dateOfBirth} onChange={(e) => { setDateOfBirth(e) }} />
                    }
                </FormCard>

                <FormCard title='Address'>
                    {formType === FormTypeView ? 
                        <label>{ address }</label> :
                        <input className="input" value={address} onChange={(e) => { setAddress(e.target.value.toUpperCase()) }} />
                    }
                </FormCard>

                <FormCard title='City'>
                    {formType === FormTypeView ? 
                        <label>{ city }</label> :
                        <input className="input" value={city} onChange={(e) => { setCity(e.target.value.toUpperCase()) }} />
                    }
                </FormCard>

                <FormCard title='Province'>
                    {formType === FormTypeView ? 
                        <label>{ province }</label> :
                        <input className="input" value={province} onChange={(e) => { setProvince(e.target.value.toUpperCase()) }} />
                    }
                </FormCard>

                <FormCard title='Country'>
                    {formType === FormTypeView ? 
                        <label>{ country }</label> :
                        <input className="input" value={country} onChange={(e) => { setCountry(e.target.value.toUpperCase()) }} />
                    }
                </FormCard>

                <FormCard title='Phone'>
                    {formType === FormTypeView ? 
                        <label>{ phone }</label> :
                        <input className="input" value={phone} onChange={(e) => { setPhone(removeNonNumeric(e.target.value)) }} />
                    }
                </FormCard>

                <FormCard title='Work Place'>
                    {formType === FormTypeView ? 
                        <label>{ workPlace }</label> :
                        <input className="input" value={workPlace} onChange={(e) => { setWorkPlace(e.target.value.toUpperCase()) }} />
                    }
                </FormCard>

                <FormCard title='Vehicle'>
                    {formType === FormTypeView ? 
                        <label>{ GetVehicle(vehicle) }</label> :
                        <Dropdown options={DropdownVehicleOptions} value={vehicle} onChange={(e) => { setVehicle(e.value) }} placeholder={"No Vehicle"} />
                    }
                </FormCard>

                {(vehicle === '1' || vehicle === '2') && (
                    <div className="mt-4">
                        <span className="text-xl font-semibold">Vehicle Detail</span>
                        <hr />

                        <div className="flex flex-col gap-3 mt-4">
                            <FormCard title='Vehicle Brand'>
                                {formType === FormTypeView ? 
                                    <label>{ vehicleBrand }</label> :
                                    <input className="input" value={vehicleBrand} onChange={(e) => { setVehicleBrand(e.target.value.toUpperCase()) }} />
                                }
                            </FormCard>

                            <FormCard title='Vehicle Model'>
                                {formType === FormTypeView ? 
                                    <label>{ vehicleModel }</label> :
                                    <input className="input" value={vehicleModel} onChange={(e) => { setVehicleModel(e.target.value.toUpperCase()) }} />
                                }
                            </FormCard>

                            <FormCard title='License Plate'>
                                {formType === FormTypeView ? 
                                    <label>{ licensePlate }</label> :
                                    <input className="input" value={licensePlate} onChange={(e) => { setLicensePlate(e.target.value.toUpperCase()) }} />
                                }
                            </FormCard>
                        </div>
                    </div>
                )}

                <div className="mt-4">
                    <span className="text-xl font-semibold">Tenant Emergency Contact</span>
                    <hr />

                    <div className="flex flex-col gap-3 mt-4">
                        <FormCard title='Contact Name'>
                            {formType === FormTypeView ? 
                                <label>{ contactName }</label> :
                                <input className="input" value={contactName} onChange={(e) => { setContactName(e.target.value.toUpperCase()) }} />
                            }
                        </FormCard>
                        
                        <FormCard title='Contact Phone'>
                            {formType === FormTypeView ? 
                                <label>{ contactPhone }</label> :
                                <input className="input" value={contactPhone} onChange={(e) => { setContactPhone(e.target.value.toUpperCase()) }} />
                            }
                        </FormCard>

                        <FormCard title='Contact Relation'>
                            {formType === FormTypeView ? 
                                <label>{ contactRelation }</label> :
                                <input className="input" value={contactRelation} onChange={(e) => { setContactRelation(e.target.value.toUpperCase()) }} />
                            }
                        </FormCard>
                    </div>
                </div>

                <div className="border-b mt-4 pb-2">
                    <span className="font-semibold text-xl">Other Document</span>
                </div>
                <div className="flex">
                    <div className="flex flex-col sm:flex-row sm:items-center w-full">
                        <div className="w-48">
                            <span>Photo ID</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            {
                                fileUrl ? <img className=" h-[180px] object-cover mx-auto border rounded-md" src={fileUrl} alt="ID" />
                                : (
                                <div className="h-[180px] w-full flex items-center justify-center border rounded-md bg-gray-100">
                                    <ImageIcon className="w-10 h-10 text-gray-400" />
                                </div>
                            )}
                            <input className="hidden" id="selectedFile" type="file" accept=".jpg, .png, .jpeg, .gif|image/*" onChange={handleChange} />
                            <button onClick={() => document.getElementById('selectedFile').click()} 
                                className={`mt-4 px-3 py-2 bg-app-matte-black text-white rounded-md text-center cursor-pointer w-full flex gap-2 justify-center 
                                        ${formType === FormTypeView ? 'hidden' : 'block'}    
                                    `}
                            >
                                <ImageIcon />
                                Add Image
                            </button>
                        </div>
                    </div>
                </div>
               
                <div className="mt-5 flex flex-wrap justify-end w-full gap-2">
                    <SaveButton onClick={saveBtnClick} visible={true} />
                    <DeleteButton onClick={deleteBtnClick} visible={ formType === FormTypeAdd ? false : (status === StatusCodeActive ? true : false) } />
                    <UnDeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === StatusCodeDelete ? true : false) : false} />
                    <BackButton onClick={backBtnClick}  />
                </div>
            </div>
            
        </MainBodyCard>
    )
}